// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3On1a","title":"AfterBackImages_title__2JNME","images":"AfterBackImages_images__2Ua5J"};